import './App.css';

function App() {
  return (
    <>
      <h1>E-CELL</h1>
    </>
  );
}

export default App;
